import React from 'react';
import {
  EdgeProps,
  EdgeLabelRenderer,
  getSmoothStepPath,
  BaseEdge,
} from 'reactflow';
import { EdgeData } from '../../types';

const SmoothStepEdgeWithLabel: React.FC<EdgeProps<EdgeData>> = (props) => {
  const {
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
    data,
    style = {},
    markerEnd,
    markerStart,
    // borderRadius is not a standard EdgeProp, remove from destructuring
  } = props;

  // Calculate path and label position using the standard function
  const [edgePath, labelX, labelY] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    // Use default borderRadius or get from data if needed: data?.borderRadius
  });

  // Ensure consistent edge style application
  const edgeStyle = {
    ...style,
    stroke: style?.stroke || '#555555', // Default color
    strokeWidth: style?.strokeWidth || 2, // Default thickness
  };

  return (
    <>
      {/* Render the base edge path */}
      <BaseEdge
        id={id}
        path={edgePath}
        markerEnd={markerEnd}
        markerStart={markerStart}
        style={edgeStyle}
      />

      {/* Render the custom label */}
      {data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              padding: '2px 4px',
              fontSize: '10px',
              fontWeight: 500,
              textAlign: 'center',
              pointerEvents: 'all',
              color: edgeStyle.stroke,
              WebkitTextStrokeWidth: '4px', // Standard property name in React style objects
              WebkitTextStrokeColor: 'var(--edge-label-shadow-color)', // Use CSS variable
              paintOrder: 'stroke fill', // Ensures stroke is drawn behind the fill
              maxHeight: '76px',
              overflowWrap: 'break-word',
              wordBreak: 'break-word',
              display: 'block',
              maxWidth: '100px', // Keep maxWidth to encourage wrapping
              lineHeight: '1.2',
              zIndex: 1000,
              backgroundColor: 'transparent'
            }}
            className="nodrag nopan" // Keep React Flow classes
          >
            {data.label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default SmoothStepEdgeWithLabel;
